import { InformationForm } from "@/features/information/components/InformationForm";

import { FC } from "react";

type TInformationCreatePageProps = {};

export const InformationCreatePage: FC<TInformationCreatePageProps> = () => {
  return <InformationForm />;
};
